module.exports = __webpack_public_path__ + "io.svg?e952bd6a40bfd19b1dac22a4e04a0853";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/io.svg
// module id = 839
// module chunks = 27